import React from 'react';
import {Button, Modal, Tooltip} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {MODAL} from "../../../../../constants/translates";
import {addMessage, callMessages} from "../../../../../helpers/flashMessage";
import {FleetExpensesModel} from "../../../../../models/FleetExpenses/FleetExpensesModel";
import FleetExpensesStore from "../../../../../stores/FleetExpensesStore";

type DeleteExpenseButtonProps = {
  expense: FleetExpensesModel<'expense'>;
};

const DeleteExpenseButton = ({ expense }: DeleteExpenseButtonProps) => {
  const onDelete = () => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_delete_custom_entity('expense'),
      onOk: async () => {
        const result: Response = await FleetExpensesStore.deleteExpense(expense.id);
        const status: number = result.status;
        if(status === 200) {
          addMessage(`The expense ${expense.id} has been deleted successfully`, 'success');
        } else {
          addMessage(`The expense ${expense.id} has not been deleted`, 'error');
        }
        callMessages();
        FleetExpensesStore.load({}, true);
      },
    });
  };

  return (
    <>
      <Tooltip placement="top" title={`Delete expense`}>
        <Button style={{ width: '25px', aspectRatio: '1/1' }} type="primary" onClick={onDelete}>
          <DeleteOutlined />
        </Button>
      </Tooltip>
    </>
  );
};

export default DeleteExpenseButton;